
'use client';

import { useEffect } from 'react';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export function KsaVisaPageAnimator() {

  useEffect(() => {
    const timer = setTimeout(() => {
        const heroTl = gsap.timeline({
            scrollTrigger: {
                trigger: 'main',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
        });
        heroTl
            .to('.gsap-ksa-hero-title', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out', delay: 0.2 })
            .to('.gsap-ksa-hero-subtitle', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6")
            .to('.gsap-ksa-hero-image', { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' }, "-=0.6");


        gsap.to('.gsap-ksa-visa-card', {
            scrollTrigger: {
                trigger: '.gsap-ksa-visa-card',
                start: 'top 85%',
                toggleActions: 'play none none none',
            },
            opacity: 1,
            y: 0,
            duration: 0.6,
            stagger: 0.15,
            ease: 'power3.out',
            delay: 0.3
        });

        gsap.to('.gsap-ksa-sidebar', {
            scrollTrigger: {
                trigger: '.gsap-ksa-sidebar',
                start: 'top 80%',
                toggleActions: 'play none none none',
            },
            opacity: 1,
            y: 0,
            duration: 1,
            ease: 'power3.out',
            delay: 0.5
        });

        gsap.utils.toArray<HTMLElement>('.gsap-ksa-section').forEach((section) => {
            gsap.to(section, {
                scrollTrigger: {
                    trigger: section,
                    start: 'top 85%',
                    toggleActions: 'play none none none',
                },
                opacity: 1,
                y: 0,
                duration: 1,
                ease: 'power3.out',
                delay: 0.2
            });
        });

    }, 0);

    return () => {
      clearTimeout(timer);
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return null;
}
